/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Camera_Station_LabelInputs */

const vi_camera_station_label = /** @type {(inputs: Camera_Station_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trạm ${i?.name}`)
};

/**

* @param {Camera_Station_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_station_label = /** @type {((inputs: Camera_Station_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Station_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_station_label(inputs)
});